import React from "react";
import { Link } from "@quintype/components";
import { array, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import ScrollSnap from "../../atoms/ScrollSnap";
import CardImage from "../../atoms/CardImage";
import PhotoStoryCard from "../PhotoStoryCard";
import { staticTexts } from "../../utils/Translate";

import "./photoRelatedStories.m.css";

const PhotoRelatedStories = ({ relatedStories, publisherAttributes }) => (
  <div styleName="wrappper" data-testid="related-photo">
    <Headline
      text={staticTexts(publisherAttributes.lang).morePhotoStories}
      headlineType={6}
      headerLevel={2}
      className="heading"
    />
    <div styleName="related-stories-wrapper-desktop">
      {relatedStories.map((item, index) => (
        <PhotoStoryCard
          key={index}
          story={item.story}
          headlineType={6}
          headerLevel={3}
          aspectRatio={[4, 3]}
          imageType="image4x3"
          cardImageWidths={[200]}
        />
      ))}
    </div>
    <div styleName="related-stories-wrapper-mobile">
      <ScrollSnap isIndicator={false}>
        {relatedStories.map((item, index) => (
          <div styleName="also-read-story" key={index}>
            <Link href={item.story.url}>
              <Headline
                text={staticTexts(publisherAttributes.lang).readMore}
                headlineType={6}
                headerLevel={2}
                className="also-read"
              />
              <div styleName="hero-image">
                <CardImage
                  story={item.story}
                  aspectRatio={[3, 2]}
                  imageType="image3x2"
                  showAlternateImage={true}
                  widths={[200]}
                />
              </div>
              <Headline text={item.story.headline} headlineType={6} headerLevel={2} className="story-headline" />
            </Link>
          </div>
        ))}
      </ScrollSnap>
    </div>
  </div>
);

PhotoRelatedStories.propTypes = {
  relatedStories: array.isRequired,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(PhotoRelatedStories);
